// extracted by mini-css-extract-plugin
export default {"wrapper":"Step9c_wrapper__RR8wN","box":"Step9c_box__WIvU6","leftColumn":"Step9c_leftColumn__jfFqj","boxItem":"Step9c_boxItem__dK2l3","list":"Step9c_list__ab7tw"};